import script from "./OrderData.vue?vue&type=script&lang=ts&setup=true&name=OrderData"
export * from "./OrderData.vue?vue&type=script&lang=ts&setup=true&name=OrderData"

const __exports__ = script;

export default __exports__